import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { newTicketTypeCreation } from "./TicketTypeAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAllTicketType } from "./TicketTypeAction";
import { FaArrowLeft } from 'react-icons/fa';

const initialState = {
    ticket_type: "",
    status: "",

}





const CreateTicketType = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const TicketTypeRef = useRef(null);
  const [status,setStatus]= useState('');
  const [ticket_type, setNewTicketType] = useState('');
  const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, formState: { errors } } = useForm();
 
  const { stiscLoading, stcstatus, stcMessage } = useSelector((state) => state.reservationEmailsList);
  
  useEffect(() => {
    dispatch(getAllTicketType());
   
}, [dispatch,stcMessage]);

  const handleOnSubmit = (e) => {
    e.preventDefault();
  
    const newTicketTypeCreation1 = {
        ticket_type,
        status
    };
   // console.log(newCurrencyCreation1);
    dispatch(newTicketTypeCreation(newTicketTypeCreation1));

    Swal.fire({
      title: 'Success!',
      text: 'Ticket Type Created Successfully',
      icon: 'success',
      confirmButtonText: 'Okay'
    })

    navigate('/ticketypesList');

  //  window.location.reload(true);
  e.target.reset();
  };
  const canSave = Boolean (ticket_type) && Boolean(status)
  
  return (
    <>
      
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Create New Ticket Type</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/ticketypesList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridTicketType">
                  <Form.Label>Ticket Type</Form.Label>
                  <Form.Control type="ticket_type" ref={TicketTypeRef}  name="ticket_type" required="true" autoComplete='off' placeholder="Enter Ticket Type" {...register("ticket_type", { required: true, mixLength: 3 })} onChange={(e) => setNewTicketType(e.target.value)}/>
    
                </Form.Group>
               
                
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" {...register("status" , { required: true })} onChange={(e) => setStatus(e.target.value)}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle' disabled={!canSave}>
              <FontAwesomeIcon icon={faRightToBracket} /> Submit
              </Button>
              </div>
              {stiscLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
         
    </>
  );
}

export default CreateTicketType;